import { Box, Button, Modal } from "@mui/material";
import { updateShareholder } from "../service/ConfigService";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const DeleteShareholderModal = ({
  modalProps = {},
  onClose,
  existingShareholder = null,
}) => {
  const handleDelete = async () => {
    const updater = updateShareholder(
      () => {},
      existingShareholder.sid,
      {
        is_affiliated: false,
        position: "any",
      },
      (resp) => {
        onClose({
          title: "Success",
          desc: "Shareholder removed successfully.",
          type: "success",
        });
      },
      (err) => {
        onClose({
          title: "Error",
          desc: "Failed to remove shareholder.",
          type: "error",
        });
      },
    );
    await updater();
  };
  return (
    <Modal {...modalProps}>
      <Box
        sx={{
          position: "absolute",
          top: "55%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          overflow: "scroll",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          minWidth: 500,
        }}
      >
        <div className='flex flex-col'>
          <div className='flex flex-row gap-2 font-semibold px-4 py-5 border-b'>
            <CloseOutlinedIcon className='cursor-pointer' onClick={onClose} />
            <h2>Shareholder Deletion</h2>
          </div>
          <div className='px-4 py-5 flex flex-col gap-6'>
            <p className='text-sm text-[#5F737F]'>
              Are you sure you want to delete{" "}
              <span className='font-bold'>{existingShareholder.name}</span> from
              affiliated shareholder list?
            </p>
            <div className='grid grid-cols-2 gap-2'>
              <Button
                variant='contained'
                className='!bg-[#556FB5] text-xs'
                onClick={onClose}
              >
                No
              </Button>
              <Button
                variant='outlined'
                className='!text-[#556FB5] text-xs'
                onClick={handleDelete}
              >
                Yes
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default DeleteShareholderModal;
